




















import { Component, Vue, Prop } from 'vue-property-decorator';
import RecordTemplateVaild from './RecordTemplateVaild.vue';
import RecordTemplateTeacher from './RecordTemplateTeacher.vue';
import { TemplateForm } from '@/components/template';

import { Record, Plan } from '@/domains/work';
import { findRecordTemplateApi, updateRecordTemplateApi, findRecordTempalteTeacherApi, updateTeacherApi } from '@/api/work/RecordApi';
import { Template, Question } from '@/domains/template';
import { Load } from '@/domains/system';
import { isNullOrUndefined } from 'util';
import { ElNotificationComponent } from 'element-ui/types/notification';
import { ElMessageBoxShortcutMethod } from 'element-ui/types/message-box';

@Component({
  name: 'RecordTemplateDialog',
  components: {
    RecordTemplateVaild,
    TemplateForm,
    RecordTemplateTeacher,
  },
})
export default class RecordTemplateDialog extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  @Prop({ default: false })
  private saved: boolean;

  /** 会话显示 */
  private visible: boolean = false;

  /** 记录 */
  private record: Record = new Record();

  /** 档案 */
  private template: Template = new Template();

  /** 保存状态 */
  private saving: boolean = false;

  /** 保存列表 */
  private saves: number[] = [1, 2, 4];

  /** 停止保存 */
  private stopSave: boolean = false;

  /** 定时器 */
  private saveInterval: NodeJS.Timer = null;

  /** 老师skxxId，当出现老师名字更改时，却有多个老师同名的情况下  */
  private skxxId: string = '';

  /** 当需要skxxId的情况下，提供列表选择 */
  private optionList: any[] = [];

  /** 当需要skxxId的情况下，显示dialog */
  private visibleIsShowTeacher: boolean = false;

  /** 保存 */
  get canSave(): boolean {
    return !isNullOrUndefined(this.record) && this.saves.indexOf(this.record.status) >= 0 && this.saved && !this.stopSave;
  }

  /** 获取记录档案 */
  private findRecordTemplate(param: Record) {
    Load.startFullLoad('正在获取听课档案，请稍后。');
    findRecordTemplateApi(param).then((result: any) => {
      this.record = Record.build(result);
      this.template = this.record.template;
      this.visible = true;
      this.autoSave();
      Load.stopFullLoad();
    }).catch(() => {
      Load.stopFullLoad();
    });
  }

  /** 自动保存档案 */
  private autoSave() {
    if (this.canSave) {
      this.saveInterval = setTimeout(() => {
        if (this.canSave) {
          if (this.saving) {
            this.autoSave();
          } else {
            this.updateRecord(true).then(() => {
              this.autoSave();
            }).catch(() => {
              this.autoSave();
            });
          }
        }
      }, 10000);
    }
  }

  /** 提交档案 */
  private commitRecord(): void {
    if (this.canSave) {
      this.vaild().then(() => {
        this.stopSave = true;
        const records: Record = new Record();
        records.plan = this.record.plan;
        records.status = 3;
        records.id = this.record.id;
        records.template = this.template;
        records.sumScore = this.record.sumScore;
        this.checkIsShuiKe(records).then(() => {
          findRecordTempalteTeacherApi(records).then(((response: any) => {
            if (response) {
              if (response.message && response.message === '上课信息中的任课教师姓名为空，是否确定使用当前姓名！') {
                this.$confirm(response.message, '警告', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'error',
                })
                .then(() => {
                  this.stopSave = true;
                  this.record.userStatus = 1;
                  this.saveRecord(3).then((record: Record) => {
                    this.close();
                  });
                });
                return;
              }
              if (response.length > 1) {
                if (this.skxxId === '') {
                  this.optionList = response;
                  this.visibleIsShowTeacher = true;
                  this.stopSave = false;
                } else {
                  let CoursePlanZsuDTO: object = null;
                  for (const item of this.optionList) {
                    if (this.skxxId === item.teacher.zgh) {
                      CoursePlanZsuDTO = item;
                      break;
                    }
                  }
                  updateTeacherApi(CoursePlanZsuDTO).then(() => {
                    this.vaild().then(() => {
                      this.stopSave = true;
                      this.saveRecord(3).then((record: Record) => {
                        this.close();
                      });
                    });
                  });
                }
              } else {
                const CoursePlanZsuDTO: object = response[0];
                updateTeacherApi(CoursePlanZsuDTO).then(() => {
                  this.vaild().then(() => {
                    this.stopSave = true;
                    this.saveRecord(3).then((record: Record) => {
                      this.close();
                    });
                  });
                });
              }
            } else {
              this.vaild().then(() => {
                this.stopSave = true;
                this.saveRecord(3).then((record: Record) => {
                  this.close();
                });
              });
            }
          })).catch((error: any) => {
            this.$confirm(error.info, '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'error',
            })
            .then(() => {
              this.stopSave = true;
              this.record.userStatus = 1;
              this.saveRecord(3).then((record: Record) => {
                this.close();
              });
              // this.vaildTeacher(error);
            });
          });
        });
      });
    }
  }

  /** 更新档案 */
  private updateRecord(auto?: boolean): Promise<Record> {
    if (this.canSave) {
      return this.saveRecord(2, auto);
    }
  }

  /** 保存档案 */
  private saveRecord(status: 2 | 3, auto?: boolean): Promise<Record> {
    const record: Record = new Record();
    record.id = this.record.id;
    record.status = status;
    record.template = this.template;
    record.sumScore = this.record.sumScore;
    record.userStatus = this.record.userStatus;
    return this.save(record, auto);
  }

  /** 保存 */
  private save(record: Record, auto?: boolean): Promise<Record> {
    return new Promise((resolve, reject) => {
      this.saving = true;
      const notify: ElNotificationComponent = auto ? undefined : this.createSaveNotift(record.status);
      updateRecordTemplateApi(record).then((result: any) => {
        this.saving = false;
        if (notify) {
          this.closeSaveNotify(record.status, notify);
        }
        resolve(record);
      }).catch(() => {
        this.saving = false;
        if (record.status === 3) { this.stopSave = false; }
        if (notify) {
          this.createFailedNotify(notify);
        }
        reject();
      });
    });
  }

  /** 校验档案数据 */
  private vaild(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.bus.$emit('record-template-vaild', resolve);
    });
  }

  /** 校验老师 */
  private vaildTeacher(error: any): void {
    this.bus.$emit('record-template-vaildTeacher', error);
  }

  /** 创建保存通知 */
  private createSaveNotift(status: number): ElNotificationComponent {
    return this.$notify.info({
      title: status === 2 ? '保存档案' : '提交档案',
      message: status === 2 ? '正在保存档案，请稍等。。。' : '正在提交档案，请稍等。。。',
      duration: 0,
    });
  }

  /** 关闭保存通知 */
  private closeSaveNotify(status: number, notify: ElNotificationComponent) {
    notify.close();
    setTimeout(() => {
      this.$notify.success({
        title: status === 2 ? '保存档案' : '提交档案',
        message: status === 2 ? '保存档案成功！' : '提交档案成功！',
      });
    }, 100);
  }

  /** 创建错误通知 */
  private createFailedNotify(notify: ElNotificationComponent) {
    notify.close();
    setTimeout(() => {
      this.$notify.error({
        title: '警告！',
        message: '保存档案发生错误，无法继续保存！',
      });
    }, 100);
  }

  /** 关闭页面 */
  private close() {
    if (this.canSave) {
      Load.startFullLoad('正在执行保存操作，请耐心等待档案自动关闭，谢谢！');
      this.closeSave();
    } else {
      clearTimeout(this.saveInterval);
      this.stopSave = true;
      this.bus.$emit('record-template-vaild-clear');
      this.$emit('refresh');
      this.visible = false;
    }
  }

  /** 关闭保存 */
  private closeSave() {
    if (this.saving) {
      setTimeout(() => {
        this.closeSave();
      }, 500);
      return;
    }

    this.updateRecord().then(() => {
      clearTimeout(this.saveInterval);
      this.stopSave = true;
      Load.stopFullLoad();
      this.bus.$emit('record-template-vaild-clear');
      this.$emit('refresh');
      this.visible = false;
    }).catch(() => {
      Load.stopFullLoad();
    });
  }

  private handler() {
    this.bus.$on('record-template-dialog', (record: Record) => {
      const param: Record = new Record();
      const template: Template = new Template();
      param.template = template;
      param.id = record.id;
      template.id = record.template.id;
      this.stopSave = false;
      this.findRecordTemplate(param);
      this.bus.$emit('plan-record-dialog-close');
    });
  }

  /** 总分小于75，或者水课多选项大于2项时，提示水课，是否确定提交 */
  private checkIsShuiKe(record: Record): Promise<void> {
    return new Promise((resolve, reject) => {
      let isMoreThan2 = false;
      record.template.questions.forEach((question: Question) => {
        if (question.remarks === '大于3' && question.type.id === 2 && question.answer.answer !== null) {
          const arr = question.answer.answer.split(',');
          if (arr.length > 2) {
            isMoreThan2 = true;
          }
        }
      });
      if (Number(record.sumScore) <= 75 || isMoreThan2) {
        const confirm = this.$confirm('是否评分有误', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          resolve();
        });
      } else {
        resolve();
      }
    });
  }

  private mounted() {
    this.handler();
  }
}
